import CryptoJS from 'crypto-js';

import { useOnce } from '@utils/gtm/hooks/useOnce';
import { getSafeLocalStorageItem } from '@utils/localStorage/getSafeLocalStorage';

export const CriteoUserInformation = () => {
  const hashStringWithSHA256 = (inputString) => {
    const wordArray = CryptoJS.enc.Utf8.parse(inputString);
    const hash = CryptoJS.SHA256(wordArray);
    return hash.toString(CryptoJS.enc.Hex);
  };

  useOnce(() => {
    try {
      const usr = JSON.parse(
        getSafeLocalStorageItem('loyaltyUserInfo') || '{}'
      );

      dataLayer.push({
        user: {
          userID: usr.customer.id,
          hashedUserID: hashStringWithSHA256(usr.customer.id).toString(),
          userRawEmail: usr.customer.email,
          hashedRawEmail: hashStringWithSHA256(usr.customer.email).toString(),
          userName: usr.customer.name,
          hashedUserName: hashStringWithSHA256(usr.customer.name).toString(),
          userSurname: usr.customer.surname,
          hashedSurname: hashStringWithSHA256(usr.customer.surname).toString(),
          userPhone: usr.customer.mobileNumber,
          hashedPhone: hashStringWithSHA256(
            usr.customer.mobileNumber
          ).toString(),
        },
      });
    } catch (err) {
      // 👇️ SyntaxError: Unexpected end of JSON input
      // console.log('error', err);
    }
  });

  return null;
};
